(function () {
  function prefersReducedMotion() {
    return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  }

  function setButtonState(btn, paused) {
    if (!btn) return;
    btn.setAttribute('aria-pressed', paused ? 'true' : 'false');
    btn.classList.toggle('is-paused', paused);
    const pauseLabel = btn.dataset.labelPause;
    const playLabel = btn.dataset.labelPlay;
    if (pauseLabel && playLabel) {
      btn.setAttribute('aria-label', paused ? playLabel : pauseLabel);
    }
  }

  function initCssPause(host) {
    if (host.dataset.motionPauseReady === 'true') return;
    host.dataset.motionPauseReady = 'true';

    const btn = host.querySelector('[data-motion-pause-toggle]');
    const target = host.querySelector('[data-motion-pause-target]');
    if (!btn || !target) return;

    let paused = prefersReducedMotion();

    function apply() {
      host.classList.toggle('is-motion-paused', paused);
      target.classList.toggle('is-motion-paused', paused);
      setButtonState(btn, paused);
    }

    btn.addEventListener('click', () => {
      paused = !paused;
      apply();
    });

    apply();
  }

  function initAll() {
    document.querySelectorAll('[data-motion-pause="css"]').forEach(initCssPause);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);

  window.JlabMotionPause = { setButtonState, prefersReducedMotion };
})();
